<template>
  <div id="app">
    <flash v-if="flashMsg">{{flashMsg}}</flash>
    <keep-alive include="TweetListPage">
      <transition name="router">
        <router-view/>
      </transition>
    </keep-alive>
  </div>
</template>

<script>
import UserApi from '@/api/UserApi'
import Flash from '@/components/Flash'
export default {
  name: 'App',
  components: {Flash},
  computed: {
    flashMsg () { return this.$store.state.flash.msg }
  },
  mounted () {
    const sp = document.getElementById('splash')
    if (sp) {
      sp.parentNode.removeChild(sp)
    }
    UserApi.getLoginStatus().then(isLoggedin => {
      const loginPages = ['/', '/login', '/WaitAuthResult']
      const currentPage = encodeURIComponent(document.location.pathname.substr(1))
      const isOnLoginPage = loginPages.indexOf(document.location.pathname) >= 0
      if (!isLoggedin && !isOnLoginPage) {
        this.$router.push(`/login?${currentPage}`)
      }
    })
  }
}
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Hiragino Kaku Gothic ProN","メイリオ", sans-serif;
}
*, *:before, *:after {
  box-sizing: border-box;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: white;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue